import { proxy } from 'valtio'
import { useSnapshot } from 'valtio/react'

interface BulkQuickConnectShortcutRequest {
  id: number
}

let nextRequestId = 0

const bulkQuickConnectShortcutStore = proxy<{
  request: BulkQuickConnectShortcutRequest | null
}>({
  request: null,
})

export function requestBulkQuickConnectShortcut() {
  nextRequestId += 1
  bulkQuickConnectShortcutStore.request = {
    id: nextRequestId,
  }
}

export function useBulkQuickConnectShortcutRequest() {
  return useSnapshot(bulkQuickConnectShortcutStore).request
}

export function clearBulkQuickConnectShortcutRequest(id: number) {
  if (bulkQuickConnectShortcutStore.request?.id === id) {
    bulkQuickConnectShortcutStore.request = null
  }
}
